import {
  ComponentRef,
  Directive,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  Type,
  ViewContainerRef,
} from '@angular/core';
import { NkDatatableRow } from '../datatable.utils';

@Directive({
  selector: '[nkDatatableRow]',
  standalone: false,
})
export class DatatableRowDirective<T> implements OnInit, OnChanges {
  @Input() public nkDatatableComponent!: Type<NkDatatableRow<T>>;
  @Input() public nkDatatableProp!: keyof T;
  @Input() public highlightText: string | undefined;
  @Input() public set nkDatatableRow(row: T) {
    this._nkDatatableRow = row;
    this._updateValue(this._nkDatatableRow);
  }
  public get nkDatatableRow(): T {
    return this._nkDatatableRow;
  }
  private _nkDatatableRow!: T;
  private _componentRef!: ComponentRef<NkDatatableRow<T>>;

  constructor(private _container: ViewContainerRef) {}

  private _updateValue(row: T): void {
    if (this._componentRef) {
      this._componentRef.instance.prop = this.nkDatatableProp;
      this._componentRef.instance.row = row;
    }
  }

  public ngOnInit(): void {
    if (this.nkDatatableComponent) {
      this._componentRef = this._container.createComponent(this.nkDatatableComponent);
      this._updateValue(this._nkDatatableRow);
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (typeof this.highlightText === 'string' && this._componentRef?.instance) {
      this._componentRef.instance.highlightText = this.highlightText;
    }
  }
}
